import Image from 'next/image';
import { useState } from 'react';

import { useStore } from '@/models/root-store';
import type { Action } from '@/utils/constants';
import { FULL_PDP_PLAN_ACTIONS, TipKey } from '@/utils/constants';

type ShippingEducationType = { showProductInfoCard: boolean; action: Action };

const ShippingEducation: React.FC<ShippingEducationType> = ({
  showProductInfoCard,
  action,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { generalStore } = useStore();
  const tipKeys = [
    TipKey.RECURRING_DELIVERY_HEADING,
    TipKey.RECURRING_DELIVERY_TIPS,
  ];

  const tips = tipKeys.map((key) => generalStore.getTipByKey(key));

  const [deliveryHeader, allTips] = tips;
  const mobilePlan = FULL_PDP_PLAN_ACTIONS.includes(action as Action);
  const padding = mobilePlan ? 'pb-3' : '';

  return (
    <div className={`px-6 ${showProductInfoCard ? 'pt-0' : 'pt-3'} ${padding}`}>
      <div className="flex w-full max-w-full flex-row items-center justify-between gap-2 pb-0">
        <div className="flex">
          <span
            className="font-interSemibold text-xs"
            dangerouslySetInnerHTML={{ __html: deliveryHeader }}
          ></span>
        </div>
        <button
          onClick={() => setIsOpen((v) => !v)}
          className={`${isOpen ? 'rotate-180' : 'rotate-0'} transition-transform duration-300`}
        >
          <Image
            src="/assets/icons/chevron-down-dark.svg"
            alt="chevron-down-mid"
            width={20}
            height={20}
          />
        </button>
      </div>
      {isOpen && (
        <>
          <div className="mt-3 flex-row rounded-xl bg-off-grey px-4 py-3">
            <div
              className="text-xs"
              dangerouslySetInnerHTML={{ __html: allTips }}
            ></div>
          </div>
          <div className="mt-2 text-xxs text-grey-dark">
            *Terms & Conditions apply
          </div>
        </>
      )}
    </div>
  );
};

export default ShippingEducation;
